import { checkValidYouthInviteRequest, saveShopifyDetails } from '../../ducks/auth.duck';
import { fetchPageAssets } from '../../ducks/hostedAssets.duck';
export const TOS_ASSET_NAME = 'terms-of-service';
export const PRIVACY_POLICY_ASSET_NAME = 'privacy-policy';

export const loadData = (params, search) => dispatch => {
  const {
    invite_id
  } = params;
  const pageAsset = {
    termsOfService: `content/pages/${TOS_ASSET_NAME}.json`,
    privacyPolicy: `content/pages/${PRIVACY_POLICY_ASSET_NAME}.json`,
  };

  if(invite_id){
     dispatch(checkValidYouthInviteRequest());
  }

  return Promise.all([
    dispatch(fetchPageAssets(pageAsset, true)),
    dispatch(saveShopifyDetails(search)),
  ]);
};
